// extracted by mini-css-extract-plugin
export default {"previews":"AttachmentsInput_previews__DMzGN"};